// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1-DLp","tab":"Tabs_tab__2f1uy","tabActive":"Tabs_tabActive__3iHML"};